import { grey } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';
import type { Components, Theme } from '@mui/material/styles';
import { ON_PRIMARY_DARK, PRIMARY_LIGHT } from './palette';

/**
 * Overrides de componentes MUI — equivalente ao
 * `sischef-app/src/theme/components/index.js`. Remove sombras dos botões
 * pra um visual mais flat.
 */
const semSombra = {
  root: { boxShadow: 'none' },
  contained: { boxShadow: 'none' },
  outlined: { boxShadow: 'none' },
  grouped: { boxShadow: 'none' },
};

const componentes: Components<Omit<Theme, 'components'>> = {
  MuiButton: {
    styleOverrides: semSombra,
    variants: [
      {
        props: { variant: 'contained', color: 'inherit' },
        style: { backgroundColor: grey[300] },
      },
    ],
  },
  MuiButtonBase: { styleOverrides: semSombra },
  MuiButtonGroup: { styleOverrides: semSombra },
  MuiFab: { styleOverrides: { root: { boxShadow: 'none' } } },
  MuiPaper: { styleOverrides: { root: { backgroundImage: 'unset' } } },
  // Header do backoffice: no dark o MUI zera o background do AppBar (o
  // `enableColorOnDark: false` padrão anula o backgroundColor no modo escuro) e
  // a barra fica da cor do fundo, igualzinha ao menu lateral. O retaguarda faz o
  // contrário: no dark troca o rosa por um mais claro (#ff4c86) com texto
  // azul-escuro por cima. Aqui repetimos esse par pra ficar no mesmo padrão.
  MuiAppBar: {
    defaultProps: { enableColorOnDark: true },
    styleOverrides: {
      colorPrimary: ({ theme }) =>
        theme.palette.mode === 'dark'
          ? { backgroundColor: PRIMARY_LIGHT, color: ON_PRIMARY_DARK }
          : {},
    },
  },
  // Item selecionado do menu lateral: rosa claro (alpha do primary), igual ao PDV.
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-selected': {
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.18 : 0.1),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.24 : 0.16),
          },
        },
      }),
    },
  },
};

export default componentes;
